import { DragElementArea, waitForRender } from '@fold-dev/core'
import React, { useContext, useEffect } from 'react'
import { TodoAddColumn, TodoAddSection, TodoContext, TodoSection, TodoTypes } from '../'

export type TodoSectionsProps = {
    sections: TodoTypes.Section[]
}

export const TodoSections = (props: TodoSectionsProps) => {
    const { sections } = props
    const { onSectionAdd, kanbanMode, noBlankSection } = useContext(TodoContext)

    const handleSectionAdd = (title: string) => {
        onSectionAdd({
            title,
            sectionIndex: sections.length - 1,
        })

        waitForRender(() => {
            const container = document.getElementsByClassName('f-todo-sections')[0]
            container.scrollTo({
                left: container.scrollWidth - container.clientWidth,
                behavior: 'smooth',
            })
        }, 200)
    }

    return (
        <DragElementArea
            areaId="sections"
            variant="lined"
            group="sections"
            direction={kanbanMode ? 'horizontal' : 'vertical'}
            className="f-todo-sections f-scrollbar">
            {sections.map((section: TodoTypes.Section & any, index: number) => (
                <TodoSection
                    {...section}
                    key={index}
                    index={index}
                    hide={
                        noBlankSection && !!section.tasks && !section.tasks.length && sections.length > 1 && index == 0
                    }
                />
            ))}
            {kanbanMode && (
                <div className="f-todo-sections__last-section-add">
                    <TodoAddColumn onAdd={handleSectionAdd} />
                </div>
            )}
        </DragElementArea>
    )
}
